/* eslint-disable import/prefer-default-export */
export const GET_BUILDER = 'builder/getBuilder';
